/**
 * Upload State Store
 * Manages file upload workflow state
 */

import { create } from 'zustand';

export type UploadStep = 'select' | 'validating' | 'uploading' | 'processing' | 'complete' | 'error';

export interface UploadState {
  step: UploadStep;
  file: File | null;
  progress: number;
  reportId: string | null;
  error: { code: string; message: string } | null;

  // Actions
  setFile: (file: File | null) => void;
  setStep: (step: UploadStep) => void;
  setProgress: (progress: number) => void;
  setReportId: (id: string) => void;
  setError: (error: { code: string; message: string } | null) => void;
  reset: () => void;
}

const initialState = {
  step: 'select' as UploadStep,
  file: null,
  progress: 0,
  reportId: null,
  error: null,
};

export const useUploadStore = create<UploadState>((set) => ({
  ...initialState,

  setFile: (file) => set({ file, error: null }),

  setStep: (step) => set({ step }),

  setProgress: (progress) => set({ progress }),

  setReportId: (reportId) => set({ reportId }),

  setError: (error) => set({ error, step: error ? 'error' : 'select' }),

  reset: () => set(initialState),
}));
